import {
  AuthorizationDeliveryMode,
  Profile,
  TokenResponse,
  UserLoginInfo
} from '@webapi/MIF.Subscription.WebApi';
import { RegistrationModel } from '@shared/extensions/user-data-extensions';
import { AdvertisementSourceDataModel } from '@signature/signature.extentions';
import {
  ClientAuthRequest,
  ClientAuthorizationStatus,
  RequestCodeClientAuthError,
  ValidateCodeClientAuthError,
  ClientType
} from './client.models';

export interface ClientState {
  clientType: ClientType | null;
  authResponse: UserLoginInfo | null;
  tokenResponse: TokenResponse | null;
  requestCodeAuthError: RequestCodeClientAuthError | null;
  validateCodeAuthError: ValidateCodeClientAuthError | null;
  authorizationDeliveryMode: AuthorizationDeliveryMode | null;
  authRequest: ClientAuthRequest | null;
  pendingProspectRegistration: RegistrationModel | null;
  pendingProspectAdvertisementSource: AdvertisementSourceDataModel | null;
  authorizedClientProfile: Profile | null;
  authorizationStatus: ClientAuthorizationStatus;
  isSubmittingAuthRequest: boolean;
  isAuthorizingClient: boolean;
}

export const initialClientState: ClientState = {
  clientType: null,
  authResponse: null,
  tokenResponse: null,
  requestCodeAuthError: null,
  validateCodeAuthError: null,
  authorizationDeliveryMode: null,
  authRequest: null,
  pendingProspectRegistration: null,
  pendingProspectAdvertisementSource: null,
  authorizedClientProfile: null,
  authorizationStatus: ClientAuthorizationStatus.Idle,
  isSubmittingAuthRequest: false,
  isAuthorizingClient: false
};
